import Vue from 'vue'
import sleep from '@/mixins/sleep'

Vue.mixin(sleep)
